<template>
    <div>
        <Header />
        <div id="actualites">
            <section class="slider">
                <div class="container-fluid">
                    <div class="row">
                        <div id="carouselHacked" class="carousel slide carousel-fade" data-ride="carousel">
                            <div class="header-backup"></div>
                            <div class="carousel-inner" role="listbox">
                                <div class="item active">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <main class="main" style="min-height: 750px;">
                <h1></h1>
                <h1 style="text-align: center;">Les nouvelles actualités</h1>
                <h1></h1>
                <div class="container">
                    <div class="row" style="margin-left: 15px">
                        <div class="col-sm-5" v-for="(actu, index) in actualites" :key="index">
                            <div class="card card-actualite">
                                <img :src="actu.image" class="img-responsive card-img" alt="image"
                                    style="max-height:450px" />
                                <div class="card-body">
                                    <h4 class="card-title">{{ actu.title }}</h4>
                                    <p class="card-text" v-html="actu.description"></p>
                                    <div style="display: grid;">
                                        <a :href="actu.link" style="margin: auto;">
                                            <input class="submit-btn" type="button" value="Voir plus" v-if="!loading">

                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </main>
        </div>

        <Footer />
    </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

export default {
    name: "Actualites",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            actualites: [],
            loading: true,
        };
    },
    async mounted() {
        try {
            const res = await fetch(`${process.env.VUE_APP_HSERVER_URL}/api/actualites`);
            const data = await res.json();
            this.actualites = data.map(actu => ({
                ...actu,
                image: actu.images && actu.images.length > 0 ? actu.images[0].url : '/assets/img/default.jpg',
                link: `/actualites/${actu.slug || actu.id}`,
            }));
        } catch (err) {
            this.actualites = [];
        } finally {
            this.loading = false;
        }
    },
};
</script>

<style scoped>
.card {
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 20px;
    background-color: #fff;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.card-img {
    width: 100%;
    height: auto;
}

.card-body {
    padding: 15px;
}

.card-title {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 18px;
}

.card-text {
    font-size: 14px;
    color: #555;
}

.card-actualite {
    box-shadow: -3px 0px 10px 2px #ccc;
}

a .submit-btn {
    width: 180px;
    height: 40px;
    float: right;
    font-size: 17px;
    color: #fff;
    background-color: #009de5;
    padding: 0;
    font-family: "BenchNine", sans-serif;
    font-weight: bold;
}
</style>